import React, { useState } from "react";
import "./navbar.css";
import Logo from "../../assests/images/logo.png";
import { FaHome, FaInfoCircle, FaPhoneAlt } from "react-icons/fa";
import { Modal, Button } from "antd";

export const Navbar = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <nav className="navbar navbar-expand-lg sticky-top custom-navbar shadow-sm">
      <div className="container-fluid px-3 px-md-4">
        {/* Brand and Logo */}
        <div className="d-flex align-items-center">
          <img src={Logo} alt="Logo" className="navbar-logo me-2" />
          <span className="navbar-brand mb-0 h1 fs-4">CrisisVision AI</span>
        </div>

        {/* Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Nav Links */}
        <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul className="navbar-nav align-items-center gap-lg-4 gap-2 pt-3 pt-lg-0">
            <li className="nav-item">
              <a className="nav-link d-flex align-items-center gap-2" href="#">
                <FaHome /> Dashboard
              </a>
            </li>
            <li className="nav-item">
              <button
                className="nav-link btn btn-link d-flex align-items-center gap-2"
                onClick={showModal}
                style={{ padding: 0, border: 'none', background: 'none' }}
              >
                <FaInfoCircle /> About
              </button>
            </li>
            <li className="nav-item">
              <a className="nav-link d-flex align-items-center gap-2" href="#" onClick={() => setShowContactModal(true)}>
                <FaPhoneAlt /> Contact
              </a>
            </li>
          </ul>
        </div>
      </div>

      <Modal title="About CrisisVision AI" open={isModalVisible} onOk={handleOk} onCancel={handleCancel} footer={[<Button key="ok" type="primary" onClick={handleOk}>OK</Button>]}> 
         <p><strong>CrisisVision AI</strong> is an advanced platform designed to monitor and raise awareness about fire hazards across the globe.</p>
          <ul>
            <li>View real-time data of <strong>over 200 active fire cases</strong> from the last 48 hours on an interactive world map, powered by NASA's FIRMS VIIRS dataset.</li>
            <li>Analyze fire activity patterns using intuitive <strong>bar and pie charts</strong> based on global wildfire data.</li>
            <li>Play an active role by <strong>uploading images</strong> of fire incidents — our AI model (trained on both IR and RGB datasets using "Learning Without Forgetting") detects and verifies fire occurrences.</li>
            <li>All fire incident data is securely stored and processed using <strong>MongoDB</strong>, ensuring real-time access and scalable insights.</li>
            <li>Soon, users can subscribe with their contact details to receive <strong>SMS and email alerts</strong> for fire updates in their region.</li>
          </ul>
          <p>We aim to empower citizens, researchers, and disaster response teams with timely, data-driven insights to act swiftly and save lives.</p>
        </Modal>
        <Modal
          title="Contact Information"
          visible={showContactModal}
          onCancel={() => setShowContactModal(false)}
          footer={[<Button onClick={() => setShowContactModal(false)}>Close</Button>]}
        >
          <div className="row">
            <div>
              <h2 style={{ fontWeight: 'bold' }}>Riya Regmi</h2>
            </div>
            <div>
              <p><strong>Email:</strong> <a href="mailto:riyaregmi2023@gmail.com">riyaregmi2023@gmail.com</a></p>
              <p><strong>LinkedIn:</strong> <a href="https://www.linkedin.com/in/riya-regmi/" target="_blank" rel="noopener noreferrer">linkedin.com/in/riya-regmi</a></p>
            </div>
          </div>
        </Modal>

      
    </nav>
  );
};
